import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    uid: null,
    token: null,
    utm: null,
    company: "toothlens"
};

const smileWhiteSlice = createSlice({
    name: 'smileWhite',
    initialState,
    reducers: {
        setAppData: (state, action) => {
            return { ...state, ...action.payload };
        },
        clearAppData: () => initialState
    }
});

export const { setAppData, clearAppData } = smileWhiteSlice.actions;
export default smileWhiteSlice.reducer;